const axios = require('axios');

import {VIGEO_URL as baseUrl } from "src/modules/shared/config/config.service"

const TarificationVigeoService = {
    /**
     * Récupère les paramètres de configuration pour la tarification vigeo
     */
    getParameters(dateEffet) {
        const url = baseUrl + `/tarificateur/parameters/${dateEffet}`
        return axios.get(url)
    },
    /**
     * Récupère les informations relatives à l'utilisateur dans le cadre de la tarification
     */
    getUserInformations() {
        const url = baseUrl + '/tarificateur/user'
        return axios.get(url)
    },
    /**
     * Soumets la tarification choisie
     */
    submitForm(data, params) {
        const url = baseUrl + '/tarificateur/submit'
        return axios.post(url, data, {params: params})
    },
    /**
     * Mets à jour le consentement
     */
    updateConsentement(data) {
        const url = baseUrl + '/tarificateur/consentement'
        return axios.post(url, data)
    },
    /**
     * Renvoie l'URL du tableau de garantie
     */
    returnWarrantyTablePdfUrl(combinaison) {
        return baseUrl + '/pdfGaranties/combinaison/' + combinaison
    }
}

export default TarificationVigeoService
